import { render, staticRenderFns } from "./SidebarLinkGroup.vue?vue&type=template&id=829072ba"
import script from "./SidebarLinkGroup.vue?vue&type=script&lang=js"
export * from "./SidebarLinkGroup.vue?vue&type=script&lang=js"
import style0 from "./SidebarLinkGroup.vue?vue&type=style&index=0&id=829072ba&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('829072ba')) {
      api.createRecord('829072ba', component.options)
    } else {
      api.reload('829072ba', component.options)
    }
    module.hot.accept("./SidebarLinkGroup.vue?vue&type=template&id=829072ba", function () {
      api.rerender('829072ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/app-sidebar/components/SidebarLinkGroup.vue"
export default component.exports